<h4>{{{video_title}}}</h4>
<div class="user">
    <img class="user-profile-picture" src="{{{user.image}}}">
    <div class="user-info">
        <p class="username">{{{user.first_name}}} {{{user.last_name}}}</p>
        <p class="role">{{{user.job_title}}}</p>
    </div>
</div>
<div class="description">
    <p class="video-description">{{{video_description}}}</p>
    {{#if button_cta_link}}
    <a class="btn learn-more-btn {{#if button_cta_fallback}}fallback{{/if}}" href="{{{button_cta_link}}}" target="_blank">{{{button_cta}}}</a>
    {{/if}}
</div>